// List of modules that should send performance metrics
export const ENABLED_MODULES_FOR_PERFORMANCE_METRICS = [
	// Jira Modules
	'jira:adminPage',
	'jira:customField',
	'jira:customFieldType',
	'jira:dashboardGadget',
	'jira:globalPage',
	'jira:issueAction',
	'jira:issueActivity',
	'jira:issueContext',
	'jira:issuePanel',
	'jira:projectPage',
	'jira:projectSettingsPage',

	// Confluence Modules
	'confluence:contentAction',
	'confluence:contentBylineItem',
	'confluence:globalPage',
	'confluence:globalSettings',
	'confluence:spacePage',
	'xen:macro',
];
